// ----------------------------------------------------------------------------
// Template: Product
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import { load } from '@shopify/theme-sections';
import 'snippets/breadcrumbs/breadcrumbs';
import 'snippets/cart-confirmation/cart-confirmation';
import 'snippets/_containers/swatches/swatches';
import 'snippets/specs-table/specs-table';
import 'snippets/product-form/product-form';
import 'sections/header/header';
import 'sections/footer/footer';
import 'sections/main-product/main-product';
import 'sections/main-product/main-product';
import 'sections/stamped-reviews-summary/stamped-reviews-summary';
import 'sections/product-details/product-details';
import 'sections/product-recommendations/product-recommendations';

// -------------------------------------
// Hooks
// -------------------------------------
document.addEventListener('DOMContentLoaded', () => {
  load('*');
});